import {IActionContext} from "../create_path_to_action";
import {setAuthAndUser} from "./set_auth_and_user";
import {setLatestEntryAction} from "./set_latest_entry";

export const setAuthAndDate = async (ctx: IActionContext<{}>) => {
    await setAuthAndUser(ctx.store);
    await setLatestEntryAction(ctx.store);
};
